<template>
    <Drop @drop="moveItem"
          style="min-height: 250px;"
            :class="{ 'min-width-board': location_set.tasks.length < 1 }"
    >
        <Drag v-if="location_set.tasks"
            :transferData="{
                location: location
             }"
        >
            <Task
                v-for="(task, $taskIndex) of location_set.tasks"
                :key="$taskIndex"
                :task="task"
                :taskIndex="$taskIndex"
                :location="location"
                :location_set="location_set"
                :board="board"
            />
        </Drag>
    </Drop>
</template>

<script>
import Task from "./Task";
import MovingPrioritiesItems from "../../mixins/MovingPrioritiesItems";
import Drop from "./Drop";
import Drag from "./Drag";

export default {
    name: "EffortValue",
    props: ['board', 'location', 'location_set'],
    mixins: [MovingPrioritiesItems],
    components: {Task, Drop, Drag},
}
</script>

<style scoped>
.min-width-board {
    min-width: 250px;
}
</style>
